import React, { useState } from "react";
import {
  Paper,
  Box,
  AppBar,
  Toolbar,
  Typography,
  Grid,
  Checkbox,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TablePagination,
  FormControl,
  Select,
  MenuItem,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputLabel,
  Divider,
} from "@material-ui/core";

const ReturnBatch = ({ open, close }) => {
  const [remarks, setRemarks] = useState("");
  return (
    <Dialog
      open={open}
      onClose={() => close(false)}
      // sx={{ width: "60%" }}
      fullWidth={true}
    >
      <DialogTitle
        sx={{
          fontWeight: "bold",
          fontSize: "20px",
        }}
      >
        Return Batch
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item md={12} sx={3}>
            <Typography
              sx={{
                fontWeight: "bold",
                fontSize: "17px",
              }}
            >
              Batch NO :
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={4}>
            <Typography
              sx={{
                fontWeight: "bold",
                fontSize: "17px",
              }}
            >
              Remarks :
            </Typography>
            <TextField
              id="outlined-basic"
              variant="outlined"
              size="small"
              type="text"
              fullWidth
              multiline
              rows={2}
              maxRows={4}
              sx={{
                width: 400,
                marginTop:"10px"
              }}
              InputProps={{ sx: { height: 80 } }}
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => close(false)}
        >
          Close
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => close(false)}
        >
          Return
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReturnBatch;
